<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <template #header>
      <Tabs v-model="tabName" @on-click="handleTab">
        <TabPane :label="$t('notPick')" name="NO" />
        <TabPane :label="$t('alreadyPick')" name="YES" />
      </Tabs>
    </template>
    <template #IMAGE="{ row }">
      <img
        @click="preview(row.photos[0])"
        style="height: 60px"
        v-if="row && row.photos && row.photos.length > 0"
        :src="row.photos[0]"
      />
    </template>
    <template #PREVIEW="{ params, visible }">
      <img style="width: 100%" v-if="visible" :src="params.src" />
    </template>
    <template #DETAILS="{ visible, params }">
      <Tracker v-if="visible" :statusId="params.row.airway_number"></Tracker>
    </template>
  </cTable>
</template>

<script>
import { getList, PickupCancel } from "@/api/order/returnPick";
import { getOrderDetails } from "@/api/order/list";
import { getCountry } from "@/api/system/country";
import Tracker from "@/base/order_tracker";
import { getAllClient } from "@/api/user/client";
import { getAgent } from "@/api/tracker/agent";
import { getSelectType } from "@/api/public";
import { getCurrency } from "@/api/finance/currency";
import { getUser } from "@/api/user/internal";
import cTable from "@/base/common/index";
export default {
  name: "returnPick",
  components: {
    cTable,
    Tracker,
  },
  async created() {
    // let deliver = (
    //   await getAgent({
    //     agent_type: "bag",
    //     status: "YES",
    //     types: "DELIVERY"
    //   })
    // ).data.payload.rows;
    let client = (await getAllClient()).data.payload.rows;
    // let reason = (await getSelectType("REFUNDS_REASON")).data.payload[
    //   "REFUNDS_REASON"
    // ];
    // let source = (await getSelectType("REFUNDS_SOURCE")).data.payload[
    //   "REFUNDS_SOURCE"
    // ];
    // let currency = (await getCurrency({ pageSize: 100 })).data.payload.rows;

    this.header.searchs.forEach(async (item) => {
      if (item.key === "to_country")
        item.options = (await getCountry()).data.payload.rows;
      if (item.key === "client_id") item.options = client;
      // if (item.key === "deliver") item.options = deliver;
      // if (item.key === "reason") item.options = reason;
      // if (item.key === "source") item.options = source;
      if (item.key === "customer_service_id")
        item.options = (
          await getUser({ standard: "CustomerService" })
        ).data.payload.rows;
    });
  },
  methods: {
    handleTab(tab) {
      // console.log(this);
      this.$refs["table"].tabName = this.tabName;
      this.$refs["table"].getList();
    },
    preview(src) {
      this.$refs["table"].getModal("preview").open({ src });
    },
  },
  data() {
    return {
      tabName: "NO",
      amount: 0,
      methods: {
        list: (params) => {
          params["pickup"] = this.tabName;
          return getList(params);
        },
        getAllClient,
        PickupCancel,
        // getDetails
      },
      config: {
        height: 630,
      },
      modals: {
        preview: {
          config: {
            title: this.$t("preview"),
          },
          contentSlot: "PREVIEW",
          footer: {
            show: false,
          },
        },
        addReturn: {
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("add", row, true).then((res) => {
                this.$page.getList();
                this.close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr",
                },
              ],
              reason: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              amount: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr",
                  type: "number",
                },
              ],
              // currency: [
              //   {
              //     required: true,
              //     message: "cannot be empty",
              //     trigger: "change"
              //   }
              // ]
              cod_remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr",
                },
              ],
            },
            formBind: {
              labelWidth: 140,
            },
            title: this.$t("add") + this.$t("returnRefund"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [
            { airway_number: 24 },
            { reason: 24 },
            { amount: 24 },
            // { currency: 24 },
            { cod_remarks: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("order_number"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_number");
              },
              methods: {
                "on-blur": ({ value, formData }) => {
                  if (!value) return;
                  getOrderDetails(value).then((res) => {
                    formData["amount"] = Number(res.data.payload.cod_amount);
                    this.amount = Number(res.data.payload.cod_amount);
                  });
                },
              },
            },
            {
              key: "reason",
              name: () => this.$t("returnRefund") + this.$t("reason"),
              component: "Select",
              options: [],
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("returnRefund") +
                  this.$t("order_desc")
                );
              },
            },
            {
              key: "amount",
              name: () => this.$t("refund") + this.$t("amount"),
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%",
              },
              default: 0,
              placeholder() {
                return this.$t("enter") + this.$t("refund") + this.$t("amount");
              },
            },
            // {
            //   key: "currency",
            //   name: () => this.$t("refund") + this.$t("currency_t"),
            //   component: "Select",
            //   options: [],
            //   config: {
            //     label: "code",
            //     value: "code"
            //   },
            //   placeholder() {
            //     return (
            //       this.$t("select") + this.$t("refund") + this.$t("currency_t")
            //     );
            //   }
            // },
            {
              key: "cod_remarks",
              name: () =>
                this.$t("modify") +
                this.$t("refund") +
                this.$t("reChAmount") +
                this.$t("order_desc"),
              component: "Input",
              bind: {
                type: "textarea",
              },
              show: ({ row }) => row["amount"] != this.amount,
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("modify") +
                  this.$t("refund") +
                  this.$t("reChAmount") +
                  this.$t("order_desc")
                );
              },
            },
            {
              key: "remarks",
              name: () => this.$t("order_desc"),
              component: "Input",
              bind: {
                type: "textarea",
              },
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
            },
          ],
        },
        show: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600,
            },
          },
          footer: { show: () => false },
        },
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm["endTime"] = time;
                }
              },
            },
          },
          // {
          //   key: "pickup",
          //   component: "Select",
          //   bind: {
          //     style: "width:150px"
          //   },
          //   placeholder() {
          //     return this.$t("whether") + this.$t("pick");
          //   },
          //   options: [
          //     { value: "YES", label: "YES" },
          //     { value: "NO", label: "NO" }
          //   ],
          //   config: {
          //     label: ({ row }) => {
          //       return this.$t(row.label);
          //     }
          //   }
          // },
          {
            key: "is_cancel",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return (
                this.$t("whether") + this.$t("cancel") + this.$t("returnPick")
              );
            },
            options: [
              { value: "YES", label: "YES" },
              { value: "NO", label: "NO" },
            ],
            config: {
              label: ({ row }) => {
                return this.$t(row.label);
              },
            },
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "customer_service_id",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "client_id",
            component: "Select",
            bind: {
              style: "width:175px",
            },
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            options: [],
            config: { label: "account", value: "id" },
          },
          // {
          //   key: "deliver",
          //   component: "Select",
          //   bind: {
          //     style: "width:175px"
          //   },
          //   placeholder() {
          //     return this.$t("select") + this.$t("localFaction");
          //   },
          //   options: [],
          //   config: {
          //     label: "agent_name",
          //     value: "agent_name"
          //   }
          // },
          // {
          //   key: "source",
          //   component: "Select",
          //   bind: {
          //     style: "width:175px"
          //   },
          //   placeholder() {
          //     return this.$t("select") + this.$t("source");
          //   },
          //   options: []
          // },
          // {
          //   key: "reason",
          //   component: "Select",
          //   bind: {
          //     style: "width:175px"
          //   },
          //   placeholder() {
          //     return this.$t("select") + this.$t("reason");
          //   },
          //   options: []
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
              // autosize: { minRows: 2, maxRows: 2 }
            },
          },
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("add") + this.$t("returnRefund"),
            //   type: "add",
            //   fnName: "addFun",
            //   bind: {
            //     type: "warning"
            //   }
            // },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$tz("批量,取消,取件"),
              type: "cancel",
              fnName: "cancel",
              bind: {
                type: "success",
              },
              show: () => this.tabName != "YES",
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            cancel() {
              this.$Modal.confirm({
                title: this.$tz("批量,取消,取件"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "PickupCancel",
                    {
                      airway_number: this.selectAll.map((t) => t.airway_number),
                    },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
            export() {
              this.exportExc();
            },
            addFun() {
              this.getModal("addReturn").open();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          component: "Button",
          copy: true,
          align: "center",
          fixed: "left",
          bind: {
            type: "primary",
            size: "small",
          },
          header: {
            copy: true,
          },
          showOverflow: false,
          width: 160,
          methods: {
            click({ row }) {
              this.$page.getModal("show").setTitle(row.airway_number);
              this.$page.getModal("show").open({ row });
            },
          },
        },
        {
          name: () => this.$t("tracker_code"),
          key: "status",
          align: "center",
          minWidth: 100,
        },
        // {
        //   name: () => this.$t("status_cn"),
        //   key: "status_cn",
        //   align: "center",
        //   minWidth: 100
        // },
        {
          name: () => this.$t("track_title"),
          key: "status_remarks",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("new_tracker_time"),
          key: "status_time",
          align: "center",
          minWidth: 110,
        },
        {
          name: () => this.$t("pickImage"),
          key: "photo",
          align: "center",
          width: 160,
          slot: "IMAGE",
        },
        {
          name: () => this.$t("returnPick") + this.$t("plan_t"),
          key: "plan",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$tz("客服"),
          key: "customer_service_name",
          minWidth: 110,
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("city_name"),
          key: "city_name",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("wheather cancel pick up"),
          key: "is_cancel",
          align: "center",
          width: 110,
          methods: {
            render({ value }) {
              return this.$t(value);
            },
          },
        },
        {
          name: () => this.$t("consignor"),
          key: "consignee_contact",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("consignorPhone"),
          key: "consignee_cellular",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("consignorAddress"),
          key: "consignee_address",
          align: "center",
          minWidth: 150,
        },
        {
          name: () => this.$t("DeclaredValue"),
          key: "values",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("order_type_t"),
          key: "type",
          align: "center",
          minWidth: 120,
        },
        {
          name: () => this.$t("appConsignorTime"),
          key: "schedule_time",
          align: "center",
          minWidth: 120,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            },
          },
        },
        {
          name: () => this.$t("length"),
          key: "length",
          align: "center",
          minWidth: 100,
          show: () => this.tabName == "YES",
        },
        {
          name: () => this.$t("width"),
          key: "width",
          align: "center",
          minWidth: 100,
          show: () => this.tabName == "YES",
        },
        {
          name: () => this.$t("height"),
          key: "height",
          align: "center",
          minWidth: 100,
          show: () => this.tabName == "YES",
        },
        {
          name: () => this.$t("charge_volume"),
          key: "charge_volume",
          align: "center",
          minWidth: 100,
          show: () => this.tabName == "YES",
        },
        {
          name: () => this.$t("check_weight"),
          key: "check_weight",
          align: "center",
          minWidth: 100,
          show: () => this.tabName == "YES",
        },
        {
          name: () => this.$t("charge_params"),
          key: "actual_weight",
          align: "center",
          minWidth: 100,
          show: () => this.tabName == "YES",
        },
        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 130,
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        // {
        //   type: "btns",
        //   width: 100,
        //   name: () => this.$t("operation"),
        //   fixed: "right",
        //   list: [
        //     {
        //       name: () => this.$t("operation"),
        //       type: "operation",
        //       fnName: "operationFun",
        //       bind: {
        //         type: "warning"
        //       }
        //     }
        //   ],

        //   methods: {
        //     operationFun({ row }) {
        //       this.getModal("operation").open({ id: row.airway_number });
        //     }
        //   }
        // }
      ],
    };
  },
};
</script>
